import apiClient from '../../utils/apiConfig';

// Action types
export const StabilityActionTypes = {
  // System status
  FETCH_SYSTEM_STATUS_REQUEST: 'FETCH_SYSTEM_STATUS_REQUEST',
  FETCH_SYSTEM_STATUS_SUCCESS: 'FETCH_SYSTEM_STATUS_SUCCESS',
  FETCH_SYSTEM_STATUS_FAILURE: 'FETCH_SYSTEM_STATUS_FAILURE',
  
  // MongoDB connections
  FETCH_MONGODB_DETAILS_REQUEST: 'FETCH_MONGODB_DETAILS_REQUEST',
  FETCH_MONGODB_DETAILS_SUCCESS: 'FETCH_MONGODB_DETAILS_SUCCESS',
  FETCH_MONGODB_DETAILS_FAILURE: 'FETCH_MONGODB_DETAILS_FAILURE',
  
  // Environment actions
  FETCH_ACTIVE_ENVIRONMENT_REQUEST: 'FETCH_ACTIVE_ENVIRONMENT_REQUEST',
  FETCH_ACTIVE_ENVIRONMENT_SUCCESS: 'FETCH_ACTIVE_ENVIRONMENT_SUCCESS',
  FETCH_ACTIVE_ENVIRONMENT_FAILURE: 'FETCH_ACTIVE_ENVIRONMENT_FAILURE',
  
  FETCH_AVAILABLE_ENVIRONMENTS_REQUEST: 'FETCH_AVAILABLE_ENVIRONMENTS_REQUEST',
  FETCH_AVAILABLE_ENVIRONMENTS_SUCCESS: 'FETCH_AVAILABLE_ENVIRONMENTS_SUCCESS',
  FETCH_AVAILABLE_ENVIRONMENTS_FAILURE: 'FETCH_AVAILABLE_ENVIRONMENTS_FAILURE',
  
  FETCH_ENVIRONMENT_DETAILS_REQUEST: 'FETCH_ENVIRONMENT_DETAILS_REQUEST',
  FETCH_ENVIRONMENT_DETAILS_SUCCESS: 'FETCH_ENVIRONMENT_DETAILS_SUCCESS',
  FETCH_ENVIRONMENT_DETAILS_FAILURE: 'FETCH_ENVIRONMENT_DETAILS_FAILURE',
  
  SET_SELECTED_DB_ENVIRONMENT: 'SET_SELECTED_DB_ENVIRONMENT',
  
  // Connection environment actions
  SET_SELECTED_CONNECTION_ENVIRONMENT: 'SET_SELECTED_CONNECTION_ENVIRONMENT',
  FETCH_CONNECTION_ENVIRONMENT_DETAILS_REQUEST: 'FETCH_CONNECTION_ENVIRONMENT_DETAILS_REQUEST',
  FETCH_CONNECTION_ENVIRONMENT_DETAILS_SUCCESS: 'FETCH_CONNECTION_ENVIRONMENT_DETAILS_SUCCESS',
  FETCH_CONNECTION_ENVIRONMENT_DETAILS_FAILURE: 'FETCH_CONNECTION_ENVIRONMENT_DETAILS_FAILURE',
  
  // Maintenance mode
  TOGGLE_MAINTENANCE_MODE_REQUEST: 'TOGGLE_MAINTENANCE_MODE_REQUEST',
  TOGGLE_MAINTENANCE_MODE_SUCCESS: 'TOGGLE_MAINTENANCE_MODE_SUCCESS',
  TOGGLE_MAINTENANCE_MODE_FAILURE: 'TOGGLE_MAINTENANCE_MODE_FAILURE',
  
  // Reset application
  RESET_APPLICATION_REQUEST: 'RESET_APPLICATION_REQUEST',
  RESET_APPLICATION_SUCCESS: 'RESET_APPLICATION_SUCCESS',
  RESET_APPLICATION_FAILURE: 'RESET_APPLICATION_FAILURE',
  
  // User limits
  UPDATE_USER_LIMITS_REQUEST: 'UPDATE_USER_LIMITS_REQUEST',
  UPDATE_USER_LIMITS_SUCCESS: 'UPDATE_USER_LIMITS_SUCCESS',
  UPDATE_USER_LIMITS_FAILURE: 'UPDATE_USER_LIMITS_FAILURE',
  
  // System notifications
  SEND_SYSTEM_NOTIFICATION_REQUEST: 'SEND_SYSTEM_NOTIFICATION_REQUEST',
  SEND_SYSTEM_NOTIFICATION_SUCCESS: 'SEND_SYSTEM_NOTIFICATION_SUCCESS',
  SEND_SYSTEM_NOTIFICATION_FAILURE: 'SEND_SYSTEM_NOTIFICATION_FAILURE',
  
  // Broadcast notifications
  SEND_BROADCAST_NOTIFICATION_REQUEST: 'SEND_BROADCAST_NOTIFICATION_REQUEST',
  SEND_BROADCAST_NOTIFICATION_SUCCESS: 'SEND_BROADCAST_NOTIFICATION_SUCCESS',
  SEND_BROADCAST_NOTIFICATION_FAILURE: 'SEND_BROADCAST_NOTIFICATION_FAILURE',
  
  // Security settings
  UPDATE_SECURITY_SETTINGS_REQUEST: 'UPDATE_SECURITY_SETTINGS_REQUEST',
  UPDATE_SECURITY_SETTINGS_SUCCESS: 'UPDATE_SECURITY_SETTINGS_SUCCESS',
  UPDATE_SECURITY_SETTINGS_FAILURE: 'UPDATE_SECURITY_SETTINGS_FAILURE',
  
  // System logs
  FETCH_SYSTEM_LOGS_REQUEST: 'FETCH_SYSTEM_LOGS_REQUEST',
  FETCH_SYSTEM_LOGS_SUCCESS: 'FETCH_SYSTEM_LOGS_SUCCESS',
  FETCH_SYSTEM_LOGS_FAILURE: 'FETCH_SYSTEM_LOGS_FAILURE',
  
  // Active tab management
  SET_ACTIVE_STABILITY_TAB: 'SET_ACTIVE_STABILITY_TAB',
  
  // Connection information
  FETCH_CONNECTION_INFO_REQUEST: 'FETCH_CONNECTION_INFO_REQUEST',
  FETCH_CONNECTION_INFO_SUCCESS: 'FETCH_CONNECTION_INFO_SUCCESS',
  FETCH_CONNECTION_INFO_FAILURE: 'FETCH_CONNECTION_INFO_FAILURE',
};

// Fetch system status
export const fetchSystemStatus = () => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.FETCH_SYSTEM_STATUS_REQUEST });
  
  try {
    const response = await apiClient.get('/api/admin/stability/status');
    dispatch({
      type: StabilityActionTypes.FETCH_SYSTEM_STATUS_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.FETCH_SYSTEM_STATUS_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Fetch MongoDB connection details
export const fetchMongoDBDetails = () => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.FETCH_MONGODB_DETAILS_REQUEST });
  
  try {
    const response = await apiClient.get('/api/admin/stability/mongodb');
    dispatch({
      type: StabilityActionTypes.FETCH_MONGODB_DETAILS_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.FETCH_MONGODB_DETAILS_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Fetch MongoDB connection details
export const fetchMongoDbDetails = () => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.FETCH_MONGODB_DETAILS_REQUEST });
  
  try {
    const response = await apiClient.get('/api/admin/db-monitor/details');
    dispatch({
      type: StabilityActionTypes.FETCH_MONGODB_DETAILS_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.FETCH_MONGODB_DETAILS_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Environment-related actions
// Set the selected DB environment in the UI (doesn't change server-side environment)
export const setSelectedDbEnvironment = (environment) => ({
  type: StabilityActionTypes.SET_SELECTED_DB_ENVIRONMENT,
  payload: environment
});

// Fetch the currently active environment from the server
export const fetchActiveEnvironment = () => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.FETCH_ACTIVE_ENVIRONMENT_REQUEST });
  
  try {
    const response = await apiClient.get('/api/admin/db-monitor/active-environment');
    dispatch({
      type: StabilityActionTypes.FETCH_ACTIVE_ENVIRONMENT_SUCCESS,
      payload: response.data.activeEnvironment
    });    // Also set as selected environment initially
    dispatch(setSelectedDbEnvironment(response.data.activeEnvironment));
    // Also set as selected environment for Connection tab to maintain consistency
    dispatch(setSelectedConnectionEnvironment(response.data.activeEnvironment));
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.FETCH_ACTIVE_ENVIRONMENT_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Fetch all available environments from the server
export const fetchAvailableEnvironments = () => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.FETCH_AVAILABLE_ENVIRONMENTS_REQUEST });
  
  try {
    const response = await apiClient.get('/api/admin/db-monitor/available-environments');
    dispatch({
      type: StabilityActionTypes.FETCH_AVAILABLE_ENVIRONMENTS_SUCCESS,
      payload: response.data.environments
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.FETCH_AVAILABLE_ENVIRONMENTS_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Fetch MongoDB details for a specific environment
export const fetchEnvironmentDetails = (environment) => async (dispatch) => {
  dispatch({ 
    type: StabilityActionTypes.FETCH_ENVIRONMENT_DETAILS_REQUEST,
    payload: { environment }
  });
  
  try {
    console.log(`Fetching environment details for ${environment}...`);
    const response = await apiClient.get(`/api/admin/db-monitor/environment/${environment}`);
    console.log(`Received environment details for ${environment}:`, 
      response.data?.mongoStatus?.connectionMonitor?.details?.length || 0, 'connections');
    
    dispatch({
      type: StabilityActionTypes.FETCH_ENVIRONMENT_DETAILS_SUCCESS,
      payload: {
        environment,
        data: response.data
      }
    });
    return { success: true, data: response.data };
  } catch (error) {
    console.error(`Error fetching environment details for ${environment}:`, error);
    dispatch({
      type: StabilityActionTypes.FETCH_ENVIRONMENT_DETAILS_FAILURE,
      payload: {
        environment,
        error: error.response?.data || { message: error.message }
      }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Toggle maintenance mode
export const toggleMaintenanceMode = (enabled, message, endTime) => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.TOGGLE_MAINTENANCE_MODE_REQUEST });
  
  try {
    const response = await apiClient.post('/api/admin/stability/maintenance', {
      enabled,
      message,
      endTime
    });
    
    dispatch({
      type: StabilityActionTypes.TOGGLE_MAINTENANCE_MODE_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.TOGGLE_MAINTENANCE_MODE_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Reset application
export const resetApplication = () => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.RESET_APPLICATION_REQUEST });
  
  try {
    const response = await apiClient.post('/api/admin/stability/reset');
    
    dispatch({
      type: StabilityActionTypes.RESET_APPLICATION_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.RESET_APPLICATION_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Update user limits
export const updateUserLimits = (limits) => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.UPDATE_USER_LIMITS_REQUEST });
  
  try {
    const response = await apiClient.put('/api/admin/stability/limits', { limits });
    
    dispatch({
      type: StabilityActionTypes.UPDATE_USER_LIMITS_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.UPDATE_USER_LIMITS_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Send system notification to a user
export const sendSystemNotification = (userId, message, priority) => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.SEND_SYSTEM_NOTIFICATION_REQUEST });
  
  try {
    const response = await apiClient.post('/api/admin/stability/notify', {
      userId,
      message,
      priority
    });
    
    dispatch({
      type: StabilityActionTypes.SEND_SYSTEM_NOTIFICATION_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.SEND_SYSTEM_NOTIFICATION_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Send broadcast notification
export const sendBroadcastNotification = (message, userType, priority) => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.SEND_BROADCAST_NOTIFICATION_REQUEST });
  
  try {
    const response = await apiClient.post('/api/admin/stability/broadcast', {
      message,
      userType,
      priority
    });
    
    dispatch({
      type: StabilityActionTypes.SEND_BROADCAST_NOTIFICATION_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.SEND_BROADCAST_NOTIFICATION_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Update security settings
export const updateSecuritySettings = (settings) => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.UPDATE_SECURITY_SETTINGS_REQUEST });
  
  try {
    const response = await apiClient.put('/api/admin/stability/security', {
      settings
    });
    
    dispatch({
      type: StabilityActionTypes.UPDATE_SECURITY_SETTINGS_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.UPDATE_SECURITY_SETTINGS_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Fetch system logs
export const fetchSystemLogs = (options = {}) => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.FETCH_SYSTEM_LOGS_REQUEST });
  
  try {
    // Convert the options to URL query parameters
    const queryParams = new URLSearchParams();
    if (options.level) queryParams.append('level', options.level);
    if (options.category) queryParams.append('category', options.category);
    if (options.startDate) queryParams.append('startDate', options.startDate);
    if (options.endDate) queryParams.append('endDate', options.endDate);
    if (options.limit) queryParams.append('limit', options.limit);
    if (options.skip) queryParams.append('skip', options.skip);
    
    const response = await apiClient.get(`/api/admin/stability/logs?${queryParams.toString()}`);
    
    dispatch({
      type: StabilityActionTypes.FETCH_SYSTEM_LOGS_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.FETCH_SYSTEM_LOGS_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Set active stability tab
export const setActiveStabilityTab = (tabIndex) => ({
  type: StabilityActionTypes.SET_ACTIVE_STABILITY_TAB,
  payload: tabIndex
});

// Fetch connection information
export const fetchConnectionInfo = () => async (dispatch) => {
  dispatch({ type: StabilityActionTypes.FETCH_CONNECTION_INFO_REQUEST });
  
  try {
    const response = await apiClient.get('/api/admin/stability/connections');
    dispatch({
      type: StabilityActionTypes.FETCH_CONNECTION_INFO_SUCCESS,
      payload: response.data
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch({
      type: StabilityActionTypes.FETCH_CONNECTION_INFO_FAILURE,
      payload: error.response?.data || { message: error.message }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};

// Connection environment-related actions
// Set the selected connection environment in the UI (doesn't change server-side environment)
export const setSelectedConnectionEnvironment = (environment) => ({
  type: StabilityActionTypes.SET_SELECTED_CONNECTION_ENVIRONMENT,
  payload: environment
});

// Fetch path configurations for a specific environment
export const fetchConnectionEnvironmentDetails = (environment) => async (dispatch) => {
  if (!environment) return;
  
  dispatch({ type: StabilityActionTypes.FETCH_CONNECTION_ENVIRONMENT_DETAILS_REQUEST });
  
  try {
    console.log(`Fetching path details for environment: ${environment}`);
    const response = await apiClient.get(`/api/admin/environment/paths/${environment}`);
    console.log('Received path details:', response.data);
    dispatch({
      type: StabilityActionTypes.FETCH_CONNECTION_ENVIRONMENT_DETAILS_SUCCESS,
      payload: {
        environment,
        details: response.data
      }
    });
    return { success: true, data: response.data };
  } catch (error) {
    console.error(`Error fetching path details for ${environment}:`, error);
    dispatch({
      type: StabilityActionTypes.FETCH_CONNECTION_ENVIRONMENT_DETAILS_FAILURE,
      payload: { environment, error: error.response?.data || { message: error.message } }
    });
    return { success: false, error: error.response?.data || error.message };
  }
};
